import HttpClient from '../HttpService';

function list(showInactives = false, search = '') {
    return HttpClient.get('/workers/company/list', {
        params: { show_inactives: showInactives, search }
    });
}

function create(data) {
    return HttpClient.post('/workers', data);
}

function update(id, data) {
    return HttpClient.put(`/workers/${id}`, data);
}

function toggleIsActive(id) {
    return HttpClient.put(`/workers/status/${id}`);
}

function getSubordinates(search = '') {
    return HttpClient.get('/workers/subordinates', {
        params: { search }
    });
}

function getBonusRules(workerId, competenceMonth, competenceYear) {
    return HttpClient.get(`/workers/${workerId}/bonus-rules`, {
        params: {
            competence_month: competenceMonth,
            competence_year: competenceYear
        }
    });
}

export default {
    list,
    create,
    update,
    toggleIsActive,
    getSubordinates,
    getBonusRules,
}
